@if (independentForm) {
  <form (ngSubmit)="onSubmitPasswordChange()" [formGroup]="formChangePassword">
    <p>{{ 'all_fields_are_required' | translate }}</p>
    <ng-container *ngTemplateOutlet="mainContent"></ng-container>
  </form>
}
@if (!independentForm) {
  <ng-container *ngTemplateOutlet="mainContent"></ng-container>
}

<ng-template #mainContent>
  <div class="row form-row mt-1">
    <div [class]="userSettingsModalFF() ? 'col-12' : 'col-md-8'">
      @if (serverErrorInfoBox) {
        <app-alert
          id="serverErrorInfoBox"
          [type]="alertType.danger"
          [header]="'error_updating_profile' | translate"
          [message]="serverErrorInfoBoxReason"
          (onClose)="closeServerInfoBox()"
        ></app-alert>
      }

      <div class="d-flex flex-column" [formGroup]="formChangePassword">
        @if (currentPasswordRequired) {
          <label id="current-password-label">{{ 'current_password' | translate }} *</label>
          <input
            type="password"
            required="true"
            id="currentPassword"
            formControlName="currentPassword"
            [attr.aria-invalid]="!isFieldValid('currentPassword')"
            autocomplete="current-password"
            class="form-element mt-1 mb-2"
            aria-labelledby="current-password-label"
          />
        }
      </div>
    </div>
  </div>

  <!-- ### -->

  <div class="row form-row mt-1">
    <div [class]="userSettingsModalFF() ? 'col-12' : 'col-md-8'">
      @if (!userSettingsModalFF()) {
        <ng-container *ngTemplateOutlet="passwordRequirements"></ng-container>
      }

      <div class="d-flex flex-column" [formGroup]="formChangePassword">
        <label id="new-password-label">
          @if (userSettingsModalFF()) {
            {{ 'new_password' | translate }} *
          } @else {
            {{ 'password' | translate }} *
          }
        </label>
        <input
          type="password"
          id="newPassword"
          formControlName="newPassword"
          [attr.aria-invalid]="!isFieldValid('newPassword')"
          autocomplete="new-password"
          class="form-element mt-1 mb-2"
          aria-labelledby="new-password-label"
        />
      </div>

      @if (userSettingsModalFF()) {
        <ng-container *ngTemplateOutlet="passwordRequirements"></ng-container>
      }
    </div>
  </div>

  <!-- ### -->

  @if (independentForm && showSubmitButton) {
    <div class="row form-row">
      <div class="col-12">
        <button type="submit" ds-button [variant]="DsButtonVariants.primary" [disabled]="formChangePassword.disabled">
          {{ submitButtonLabel | translate }}
        </button>
      </div>
    </div>
  }
</ng-template>

<ng-template #passwordRequirements>
  <p>{{ 'your_password_needs_to_meet_following_requirements' | translate }}</p>

  @if (formErrorInfoBox) {
    <app-alert
      id="formErrorInfoBox"
      [type]="alertType.danger"
      [header]="'error_updating_profile' | translate"
      [message]="formErrorInfoBoxReason"
      (onClose)="closeFormInfoBox()"
    ></app-alert>
  }

  @if (formChecklist$ | async; as formChecklist) {
    <ul>
      @for (error of formChecklist; track $index) {
        <li [style.list-style-type]="'none'" class="ms-2 my-2">
          @if (!error.valid) {
            <ds-icon [icon]="Icons.CircleExclamation" class="error"></ds-icon>
          }
          @if (error.valid) {
            <ds-icon [iconStyle]="IconStyles.Solid" [icon]="Icons.SquareCheck" class="valid"></ds-icon>
          }
          {{ error.translation }}
        </li>
      }
    </ul>
  }
</ng-template>
